<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-21 16:42:34
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-10-24 17:57:42
 * @FilePath: \sns-user-frontend\src\views\thread\web\components\thread.vue
 * @Description: 帖子详情
-->

<template>
  <div class="thread-main" ref="threadMain">
    <!-- 精选 -->
    <div class="top-tag">
      <div class="active-tag">
        <ActivityTag :type="campaignType" v-if="campaignType"/>
        <ActivityTag :type="0" v-if="threadInfo.type === 4"/>
        <TooltipTag v-if="threadInfo.verified" />
      </div>
      <div v-if="threadInfo?.stamp*1" class="best-pick">
        <!-- <svg-icon :name="`icon-best-pick-${brandName}`"></svg-icon> -->
        <img :src="bestMedal[brandName]"/>
        <span>{{ $t('highlights') }}</span>
      </div>
    </div>
    <!-- 标题 -->
    <p class="subject">
      {{threadInfo.subject}}
    </p>
    <!-- 帖子信息 -->
    <div class="thread-info">
      <div class="thread-info-l">
        <!-- 创建时间 -->
        <span class="time">
          {{$timeFormat(threadInfo.ctime)}}
        </span>
        <!-- 最近编辑时间 -->
        <span v-if="threadInfo.ctime !== threadInfo.mtime" class="time">
          {{$t('lastEdit')}} {{$timeFormat(threadInfo.mtime)}}
        </span>
      </div>
      <div class="thread-info-r">
        <!-- 点赞量 -->
        <div class="thread-info-r-icon">
          <Like
            :uid="avatarInfo.uid"
            :id="threadInfo.id" 
            :count="threadCount.praiseCount" 
            :status="threadInfo.praised"
            @update:count="updateCount"
            @update:status="updateStatus"
          />
          <span>{{$numFormat(threadCount.praiseCount)}}</span>
        </div>
        <!-- 评论量 -->
        <div class="thread-info-r-icon icon-hint">
          <svg-icon name="icon-msg" />
          <span>{{$numFormat(threadCount.commentCount)}}</span>
        </div>
        <!-- 浏览量 -->
        <div class="thread-info-r-icon icon-hint">
          <svg-icon name="icon-view" />
          <span>{{$numFormat(threadCount.viewCount)}}</span>
        </div>
      </div>
    </div>
    <p class="model" v-if="threadInfo.model">{{ threadInfo.model }}</p>

    <!-- 正文 -->
    <article v-html="threadInfo.content" ref="articleRef"></article>
    <!-- 投票 -->
    <template v-if="threadInfo.type === 4">
      <div 
        v-for="(poll, index) in threadInfo.options" 
        :key="index"
        class="poll-option"
        :class="[
          poll.polled ? 'polled' : '',
          !Number(threadInfo.remainTime) ? 'finished' : '',
          uid !== avatarInfo.uid ? 'visitor' : 'owner'
        ]"
        @click="onPoll(poll)"
      >
        <!-- 投票标题 -->
        <el-radio 
          :modelValue="poll.polled ? poll.id : currentVoteData.id" 
          :label="poll.id"
          :disabled="(uid === avatarInfo.uid) || Boolean(threadInfo.polled)"
        >
          {{ poll.title }}
        </el-radio>
        <!-- 投票图片 -->
        <ObImg
          v-if="poll.attachments"
          :src="poll.attachments"
          formatWidth="840"
          :style="{height: poll.height}"
          @click="onPreviewPollImage(poll.attachments)"
        />
        <!-- 票数比例 -->
        <el-progress
          v-if="threadInfo.polled || !Number(threadInfo.remainTime) || uid === avatarInfo.uid"
          :class="[!poll.rate ? 'norate' : 'rate']"
          :percentage="poll.rate" 
          :stroke-width="4"
        >
          <span>{{ poll.rate?.toFixed(1) }}%</span>
        </el-progress>
      </div>
    </template>
    <div class="thread-main-other">
      <!-- 话题 -->
      <div class="topics" v-if="state.topicInfo.length">
        <span class="topics-name" v-for="i in state.topicInfo">#{{ i.name }}</span>
      </div>
      <div v-if="isHideContent" class="hidden-content" @click="scrollToComent"
      v-html="$t('threadPage.hiddenTips')">
      </div>
      <div class="thread-main-other-bt">
        <!-- 圈子标识 -->
        <CircleLabel :circleInfo="circleInfo" :loginIdentityType="threadInfo?.loginIdentityType"></CircleLabel>
        <!-- 投票信息 -->
        <div class="poll-detail" v-if="threadInfo.type === 4">
          <!-- 总票数 -->
          <span>{{$formatVote(threadInfo.vote)}}</span>
          <!-- 投票结束时间 -->
          <span>{{$timeCountDown(threadInfo.remainTime)}}</span>
        </div>
      </div>
    </div>
    <div class="action">
      <button :class="threadInfo.praised ? 'like' : 'unlike'" @click="onLike">
        <Like
          ref="likeRef"
          :uid="avatarInfo.uid"
          :id="threadInfo.id" 
          :count="threadCount.praiseCount" 
          :status="threadInfo.praised"
          @update:count="updateCount"
          @update:status="updateStatus"
        />
        <span>{{$numFormat(threadCount.praiseCount)}} {{$t('like', threadCount.praiseCount)}}</span>
      </button>
      <button @click="onShare">
        <svg-icon name="icon-share" />
        <span>{{$t('share')}}</span>
      </button>
      <Share v-model="visible" :info="props.modelValue"/>
    </div>
  </div>
  <!-- 投票确认弹窗 -->
  <Dialog 
    v-model:visible="dialogVisible"
    :title="$t('confirmVoteTitle')"
    @onConfirm="onConfirmPoll"
  >
    <div class="poll-card">
      <span>{{currentVoteData.title}}</span>
      <ObImg
        v-if="currentVoteData.attachments"
        :src="currentVoteData.attachments"
      />
    </div>
  </Dialog>
  <WebImgPreview 
    v-model:visible="showPreview"
    :previewList="imgPreviewList"
    :previewIndex="previewIndex"
  />
  <WebImgPreview 
    v-model:visible="showPollPreview"
    :previewList="pollPreviewList"
    :previewIndex="previewIndex"
  />
</template>

<script setup>
import filter from '@/utils/filter'
import http from '@/service'
import { useUserStore } from '@/stores/user'
import { compare, getYoutubeId } from '@/utils'
import { storeToRefs } from 'pinia';
import TooltipTag from '@/components/tooltipTag'
import oppoBest from '@/assets/photo/oppoBest.png'
import oneplusBest from '@/assets/photo/oneplusBest.png'

const route = useRoute()

const { proxy } = getCurrentInstance()

const brandName = ref(import.meta.env.VITE_BRAND.toLowerCase())

const bestMedal = ref({
  oppo: oppoBest,
  oneplus: oneplusBest
})

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

// 获取主态id
const userStore = useUserStore()
const { uid } = storeToRefs(userStore)
const articleRef = ref(null)

const showPollPreview = ref(false)
const pollPreviewList = ref([])

// 帖子信息
const threadInfo = ref({})
// 帖子相关数量信息
const threadCount = ref({})
// 帖子作者信息
const avatarInfo = ref({})
// 帖子所属圈子
const circleInfo = ref({})

const state = reactive({
  topicInfo: [], // 话题数据
})

// 是否隐藏贴
const isHideContent = computed(() => {
  return (threadInfo.value.permission === 2 || threadInfo.value.permission === 3) && !threadInfo.value.hideContent
})

// 活动标签状态
const campaignType = ref(null)
const getCampaignStatus = async () => {
  const { code, msg, data } = await http.getLotteryThreadStatus({
    tid: route.params.id,
    campaignType: threadInfo.value.campaignType
  })
  campaignType.value = Number(data.endTime) <= Date.parse(new Date()) ? 3 : threadInfo.value.campaignType
}

// 监听目标父节点
const threadMain = ref()

// 监听视频容器是否在视觉窗口内，不在则暂停视频播放
const threadObserve = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    const { intersectionRatio, target } = entry
    // 视频不可见停止播放
    if (Array.from(target.classList).includes('plyr')) {
      if (!intersectionRatio && Array.from(target.classList).includes('plyr--playing')) {
        target.getElementsByClassName('plyr__control--overlaid')[0].click()
      }
    }
    // 图片懒加载
    if (target.tagName.toUpperCase() === 'IMG') {
      if (entry.isIntersecting && target.dataset.src) {
        target.src = target.dataset.src
        target.dataset.src && target.attributes.removeNamedItem('data-src')
        threadObserve.unobserve(target)
      }
    }
  })
}, {
  root: null, // 边界值参照节点，必须为监听元素的祖先元素
  rootMargin: '0px', // 边界触发临界值，左右上下
  threshold: [0, 0.2, 0.5], // 触发回调的节点，0表示元素刚完全不可见，1表示元素刚完全可见，0.5表示元素可见了一半等
});

// 正文中的视频标签列表
let videoClassList = reactive([])

const initPlyrVideo = async (attachments = []) => {
  // 获取所有video标签
  for( const [index, i] of Array.from(articleRef.value.getElementsByTagName('video')).entries()) {
    // 视频插件配置
    let plyrOption = reactive({
      controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'settings', 'pip', 'airplay', 'fullscreen'],
      resetOnEnd: true, // 播放结束进度条重置
      ratio: '16:9',  // 视频宽高比
      storage: {  // 不记录用户设置
        enabled: false
      }
    })
    // 视频源数据
    let source = {
      type: 'video',
    }
    
    // 社区视频
    if (i.dataset.type === 'file') {
      const attach = attachments.find(a => a.id === i.dataset.value)
      // 存在不同帧频视频
      if (Object.keys(attach).length >= 0) {
        const { transcodeInfo, snapshot, url } = attach || {}
        if (transcodeInfo && transcodeInfo.length) {
          source.sources = transcodeInfo.map(t => {
            return {
              src: t.url,
              size: Number(t.transType)
            }
          })
        } else {
          // 无不同帧频
          source.sources = [{
            src: url
          }]
        }
        // 封面图
        source.poster = snapshot ? filter.formatImg(snapshot, 792) : ''
        // 帧频选择列表
        const options =  transcodeInfo?.length ? source.sources.map(i => i.size) : []
        // 插入选择视频帧频功能
        if (options.length) {
          plyrOption.quality = {
            default: Math.min(...options),  // 默认展示最低帧频
            options
          }
        }
      }
    } else {
      // youtube视频
      plyrOption.youtube = {
        noCookie: true  // 禁止youtube跟踪观看行为
      }
      // 加载YouTube视频源
      const youtubeId = getYoutubeId(i.dataset.src)
      source.sources = [{
        src: `https://www.youtube.com/embed/${youtubeId}`,
        provider: 'youtube'
      }]
    }
    const { default: Plyr } = await import('plyr');

    // 初始化
    videoClassList[index] = new Plyr(i, { ...plyrOption })
    // 加载视频源
    videoClassList[index].source = source
    // 视频加载完成开始监听视频容器
    videoClassList[index].on('ready', (event) => {
      threadObserve.observe(event.target)
    });
    // 视频播放互斥，禁止同时播放多个视频
    videoClassList[index].on('play', (event) => {
      // // 获取所有视频容器
      videoClassList.forEach(i => {
        if (i.playing && i.id !== event.detail.plyr.id) {
          i.pause()
        }
      })
    });
  }
}

const imgPreviewList = ref([])
const showPreview = ref(false)
const previewIndex = ref(0)
const imgLazyLoad = () => {
  const { attachments = [] } = threadInfo.value
  if (attachments.length) {
    let imgList = attachments.filter(a => {
      return (a.type === 1 || a.oliveInfo) && !threadInfo.value.options?.map(i => i.attachments).includes(a.url)
    })
    imgPreviewList.value = imgList.map(i => {
      if(i.oliveInfo){
        return {
          type:5,
          url:i.url,
          ...i?.oliveInfo
        }
      }
      return i.url
    })
  }
  Array.from(document.querySelector('article').querySelectorAll('img[data-src]')).forEach((img, index) => {
    threadObserve.observe(img)
    img.addEventListener('click', e => {
      previewIndex.value = index
      showPreview.value = true
    })
  })
}

// 更新点赞数
const updateCount = (count) => {
  threadCount.value.praiseCount = count
  props.modelValue.threadStat.praiseCount = count
}
// 更新点赞状态
const updateStatus = (status) => {
  threadInfo.value.praised = status
  props.modelValue.praised = status
}

// 点赞组件引用
const likeRef = ref(null)
// 调用点赞组件方法
const onLike = () => {
  likeRef.value.onClickIcon()
}

// 分享弹窗开关
const visible = ref(false)

// 分享
const onShare = () => {
  let topic = ''
  if (threadInfo.value && threadInfo.value.topicInfo) {
    JSON.parse(threadInfo.value.topicInfo).forEach((item, index) => {
      topic += item.name + (JSON.parse(threadInfo.value?.topicInfo).length - 1  === index ? '' : ' + ')
    })
  }
  proxy.$ga('thread_share_entry', {
    "screen_name": route.name,
    "thread_category": props.modelValue?.type,
    "thread_id": props.modelValue?.id,
    "circle_id": props.modelValue?.circleBasicInfo?.id,
    "circle_name": props.modelValue?.circleBasicInfo?.name,
    "topic": topic,
    "author_id": props.modelValue?.publishUserInfo?.uid
  })
  visible.value = true
}

// 弹窗开关
const dialogVisible = ref(false)
// 投票对象
const currentVoteData = ref({})
// 投票前二次确认
const onPoll = (val) => {
  const { polled, remainTime} = threadInfo.value
  if (uid.value === avatarInfo.value.uid || polled || !Number(remainTime)) return
  currentVoteData.value = val
  dialogVisible.value = true
}
// 确认投票
const onConfirmPoll = async () => {
  const { code, msg, data } = await http.onPoll({
    id: currentVoteData.value.id,
    tid: threadInfo.value.id
  })
  if (code === 200 && data) {
    // 排序
    data.sort(compare('sort'))
    // 投票项数据更新
    threadInfo.value.options = data.map((i, index) => {
      return {
        attachments: threadInfo.value.options[index].attachments,
        id: i.id,
        polled: i.id === currentVoteData.value.id,
        rate: i.rate,
        sort: index,
        title: threadInfo.value.options[index].title,
        vote: i.vote
      }
    })
    // 计算总票数
    threadInfo.value.vote = data.reduce((prev, next) => {
      return prev + next.vote
    }, 0)
    threadInfo.value.polled = 1
    dialogVisible.value = false
  }
  proxy.$toast({
    message: `${proxy.$t('poll')} ${code === 200 ? proxy.$t('success') : proxy.$t('fail')}`
  })
}

function scrollToComent () {
  document.querySelector('.comment-menu').scrollIntoView({
    block: 'center',
    behavior: 'smooth'
  })
}

function onPreviewPollImage (path) {
  showPollPreview.value = true
  pollPreviewList.value = [path]
  previewIndex.value = 0
}

watch(() => props.modelValue, (val) => {
   // 更新所需数据
  if (val && Object.keys(val).length) {
    threadInfo.value = { ...val }
    if (threadInfo.value.campaignType) {
      getCampaignStatus()
    }
    threadCount.value = { ...val.threadStat }
    avatarInfo.value = { ...val.publishUserInfo }
    circleInfo.value = { ...val.circleBasicInfo }
    state.topicInfo = val.topicInfo ? JSON.parse(val.topicInfo.replace(/\"id\":(\d+)/g,'"id":"$1"')) : []
  }
  setTimeout(() => {
    // 视频插件初始化
    initPlyrVideo(threadInfo.value.attachments)
    // 图片懒加载
    imgLazyLoad()
  }, 500)
  try {
    // 帖子阅读完成埋点
    let threadReadObserve = new IntersectionObserver((a,b) => {
      if (a[0].intersectionRatio > 0) {
        // 帖子曝光 埋点
        // try{
          proxy.$ga('thread_completed', {
            "screen_name": route.name,
            "thread_category": props.modelValue?.type,
            "thread_id": props.modelValue?.id,
            "circle_id": props.modelValue?.circleBasicInfo?.id,
            "circle_name": props.modelValue?.circleBasicInfo?.name,
          })
        // }catch(e){}
        threadReadObserve.unobserve(document.querySelector(`.thread-main-other`))
      }
    });
    threadReadObserve.observe(document.querySelector(`.thread-main-other`))
  } catch (error) {
    
  }
}, {
  immediate: true,
  deep: true
})

onMounted(async () => {
  
})


</script>

<style lang="postcss" scoped>
.thread-main {
  padding-top: 100px;
  .top-tag {
    display: flex;
    align-items: center;
  }
  .active-tag {
    display: inline-block;
    font-size: 0;
    margin-bottom: 16px;
    .activity-tag {
      margin-right: 6px;
    }
  }
  .best-pick {
    display: inline-flex;
    align-items: center;
    margin: 0 0 16px 0;
    img {
      width: 20px;
      height: 20px;
    }
    span {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.55);
      margin-left: 4px;
    }
  }
  .subject {
    word-break: break-word;
    font-size: 24px;
    line-height: 120%;
    margin-bottom: 18px;
    &:empty {
      margin-bottom: 4px;
    }
  }
  &-other {
    display: flex;
    flex-flow: column wrap;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    margin-top: 32px;
    &-bt {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
    .hidden-content {
      width: 100%;
      padding: 12px 0px;
      border-radius: 2px;
      text-align: center;
      font-size: 14px;
      color: var(--text-secondary);
      background-color: #F9F9F9;
      margin-bottom: 20px;
      cursor: pointer;
    }
    .topics {
      display: flex;
      flex-flow: row nowrap;
      justify-content:flex-start;
      align-items: center;
      margin: 0 0 24px;
      &-name {
        font-size: 18px;
        color: var(--ob-blue);
        margin-left: 8px !important;
      }
    }
    .topics
    :deep(.circle-tag) {
      width: fit-content;
      .svg-icon {
        width: 16px;
        height: 16px;
      }
    }
    .poll-detail {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-start;
      flex-shrink: 0;
      span {
        font-size: 16px;
        line-height: 120%;
        color: var(--text-hint);
        &:first-child {
          margin-right: 24px;
        }
      }
    }
  }
}
.thread-info {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  .time {
    font-size: 16px;
    color: var(--text-hint);
    margin-right: 24px;
  }
  &-r {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    .svg-icon {
      width: 24px;
      height: 24px;
      margin-right: 4px;
    }
    &-icon {
      display: flex;
      flex-flow: row;
      align-items: center;
      justify-content: flex-start;
      margin-right: 24px;
      span {
        font-size: 16px;
        line-height: 120%;
        color: var(--text-hint);
      }
      &:last-of-type {
        margin-right: 0;
      }
    }
    .icon-unlike {
      color: var(--text-hint)
    }
    .icon-hint {
      .svg-icon {
        color: var(--text-hint);
      }
    }
  }
}
.model {
  font-size: 16px;
  line-height: 120%;
  color: var(--text-hint);
  margin-top: 8px;
}
article {
  font-size: 18px;
  word-break: break-word;
  color: rgba(0, 0, 0, 0.85);
  line-height: 150%;
  margin-top: 65px;
  :deep(a) {
    color: var(--theme);
  }
  :deep(a[data-type="link"]) {
    text-decoration: underline;
  }
  :deep(p,span,div,strong,a) {
    line-height: 150%;
  }
  :deep(video) {
    width: 792px;
    aspect-ratio: 16/9;
  }
  :deep(img) {
    display: block;
    background-color: var(--color-background-tertiary);
  }
  :deep(img[data-type="live_self"]) {
    width:36px!important;
    height:36px!important;
    position: absolute;
    top: 16px!important;
    left: 16px!important;
    z-index: 99;
    background: transparent;
    margin:0;
  }
  :deep(img[data-type="sticker_self"]) {
    width:36px!important;
    height:auto;
    display:inline;
    vertical-align: bottom;
    margin:0 2px !important;
    outline:none;
    background-color:transparent;
    pointer-events: none;
  }
  :deep(img:not([src])) {
    /* opacity: 0; */
    background: url('@/assets/photo/loading.gif') center no-repeat;
    background-size: 20%;
  }
  :deep(div:has(img[data-value])) {
    position:relative;
    margin: 0 auto;
  }
  :deep(img[data-value]) {
    margin: 18px auto;
  }
  :deep(.plyr--video) {
    display: block;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    --plyr-color-main: var(--theme);
    --plyr-video-background: transparent;
    width: 792px;
    margin: 18px 0;
    .plyr__control--overlaid {
      --plyr-control-spacing: 20px;
      --plyr-control-icon-size: 30px;
    }
    .plyr__poster {
      background-size: cover;
    }
    & *{
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
    }
    &:fullscreen video {
      width: 100%;
    }
  }
  :deep(ol) {
    list-style: decimal !important;
    padding-left: 30px !important;
    li {
      list-style: decimal !important;
      &::marker {
        padding-left: 30px !important;
      }
      ol {
        list-style: decimal !important;
        padding-left: 30px !important;
      }
      ul {
        list-style: disc !important;
        padding-left: 30px !important;
      }
    }
    img {
      width: 100% !important;
      height: auto !important;
    }
  }
  
  :deep(ul) {
    list-style: disc !important;
    padding-left: 30px !important;
    li {
      list-style: disc !important;
      &::marker {
        padding-left: 30px !important;
      }
      ol {
        list-style: decimal !important;
        padding-left: 30px !important;
      }
      ul {
        list-style: disc !important;
        padding-left: 30px !important;
      }
    }
    img {
      width: 100% !important;
      height: auto !important;
    }
  }
  :deep(hr) {
    height: 1px;
    border: 0;
    box-shadow: 0 0.33px 0 0 var(--line);
    margin: 24px 0;
  }
}


.poll-option {
  margin-top: 24px;
  padding: 24px;
  border-radius: 12px;
  background-color: #F9F9F9;
  .el-radio {
    display: flex;
    align-items: baseline;
    justify-content: flex-start;
    height: auto;
    white-space: pre-line;
    :deep(.el-radio__inner) {
      width: 18px;
      height: 18px;
      cursor: pointer !important;
      &::after {
        width: 8px;
        height: 8px;
      }
    }
    :deep(.el-radio__label) {
      font-size: 18px;
      color: unset;
      cursor: pointer !important;
      word-break: break-word;
    }
    & .is-disabled {
      :deep(.el-radio__inner) {
        cursor: pointer !important;
      }
      :deep(.el-radio__label) {
        cursor: pointer !important;
      }
    }
  }
  .ob-image {
    width: 280px;
    margin-top: 8px;
  }
  .norate {
    :deep(.el-progress-bar__outer) {
      background-color: rgba(0, 0, 0, .15);
      width: 4px;
      height: 4px;
    }
  }
  .rate {
    :deep(.el-progress-bar__outer) {
      background-color: transparent;
    }
  }
  .el-progress {
    --el-color-primary: rgba(0, 0, 0, .15);
    --el-border-color-lighter: transparent;
    --el-text-color-regular: var(--text-secondary);
    margin-top: 8px;
    :deep(.el-progress__text) {
      font-size: 14px !important;
      line-height: 16.8px;
    }
  }
}
.polled {
  .el-progress {
    --el-color-primary: #0080FF;
  }
}
.owner {
  .el-progress {
    --el-color-primary: #0080FF;
  }
}
.visitor {
  .el-progress {
    --el-text-color-regular: var(--text-hint);
  }
}
.finished {
  .el-progress {
    --el-border-color-lighter: var(--background-hint);
    --el-text-color-regular: var(--text-secondary);
    
  }
}

.poll-card {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 312px;
  margin: 24px;
  padding: 16px;
  background-color: var(--background-listpressed);
  border-radius: 8px;
  span {
    font-size: 16px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    word-break: break-word;
    overflow: hidden;
  }
  .ob-image {
    flex-shrink: 0;
    width: 64px;
    height: 64px;
    margin-left: 8px;
    border-radius: 8px;
  }
}

.action {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  margin: 32px 0 96px;
  
  .like {
    background-color: var(--background-light);
    color: var(--text-primary);
  }
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 180px;
    height: 48px;
    font-size: 16px;
    font-family: "orbit-M";
    color: #FFF;
    border: none;
    background-color: var(--theme);
    border-radius: var(--button-radius);
    .svg-icon {
      width: 24px;
      height: 24px;
      margin-right: 8px;
      color: #FFF;
    }
    &:first-child {
      margin-right: 24px;
    }
  }
}
</style>

<style lang="postcss">
article *::selection {
  color: rgba(0, 0, 0, 0.85);
  background: var(--theme-quote);
}
</style>